'use client';
import React, { useState } from 'react';
import Modal from 'react-modal';
import MWSVG from '@/components/common/svg';
import { InlineWidget } from 'react-calendly';
import ContactForm from '@/components/common/contact-form';

const UsaHero = () => {
    const [modalIsOpen, setIsOpen] = useState(false);

    const customStyles = {
        overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.6)',
            padding: 0,
        },
        content: {
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#fff',
            border: '0',
            maxWidth: '600px',
            width: '90%',
            padding: '0',
            paddingTop: '20px',
        },
    };

    return (
        <>
            <section className="hero relative aiml-banner-video overflow-hidden">
                {/* Background Video */}
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="/media/usa-hero-section-bg.mp4" type="video/mp4" />
                    </video>
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>

                <div className="container lg:container md:mx-auto relative z-[1] py-10 lg:py-16">
                    <div className="row grid lg:grid-cols-12 gap-8 lg:gap-10 items-start">
                        {/* Left Content */}
                        <div className="lg:col-span-6 flex flex-col gap-5">
                            <div>
                                <div className="flex items-center gap-2.5 gradient-border">
                                    <span className="fs-md fw-600 gradient-text">May 7 to June 27, 2026</span>
                                </div>
                            </div>

                            <h2 className="mb-0 text-white">
                                <div>Meet Deep Trivedi in the USA:</div>
                                <div>AI Strategy, Modernization, and Intelligent Systems</div>
                            </h2>

                            <div className="text-white fs-md fw-400">
                                Deep Trivedi, CTO at Moweb Technologies, is visiting the USA from 7 May to 27 June 2026 for
                                selective 1:1 leadership conversations with enterprise leaders, founders, technology teams, and
                                strategic partners.
                            </div>

                            <div className="text-white fs-md fw-400">
                                Discuss how your organization can operationalize AI, modernize legacy systems, unlock data value,
                                and build intelligent digital systems with measurable business impact.
                            </div>

                            <button
                                className="btn btn-primary self-start mb-7"
                                onClick={() => setIsOpen(true)}
                                aria-labelledby="scheduleLabel"
                            >
                                Schedule a 1:1 Meeting
                            </button>

                            {/* Badge Images */}
                            <div className="flex sm:gap-[7px] md:gap-[25px] flex-wrap mt-2">
                                <img
                                    src="/img/ic-industry-white.svg"
                                    alt="Industry"
                                    className="sm:w-[70px] sm:h-[70px] md:w-[132px] md:h-[72px]"
                                />

                                <img
                                    src="/img/ic-iso-white.svg"
                                    alt="ISO Certified"
                                    width={85}
                                    height={85}
                                    className="sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[80px]"
                                />
                                <img
                                    src="/img/ic-cmmi-white.svg"
                                    alt="CMMI"
                                    width={85}
                                    height={85}
                                    className="sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[80px]"
                                />

                                <img
                                    src="/img/ic-project-white.svg"
                                    alt="Projects"
                                    className="sm:w-[70px] sm:h-[70px] md:w-[132px] md:h-[72px]"
                                />
                            </div>
                        </div>

                        {/* Right: Contact Form */}
                        <div className="lg:col-span-6">
                            <ContactForm
                                wrapperClassName="w-full"
                                title="Request a 1:1 Meeting with Deep"
                                titleClassName="gradient-text"
                                subtitle={
                                    <span>
                                        Available for in-person and virtual meetings from 7 May to 27 June 2026. Limited slots
                                        across selected the USA cities.
                                    </span>
                                }
                                requestFromPage="lets-meet-usa"
                            />
                        </div>
                    </div>
                    <span id="ai-capabilities"></span>
                </div>
            </section>

            {/* Calendly Modal */}
            <Modal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)} style={customStyles}>
                <div
                    onClick={() => setIsOpen(false)}
                    className="text-secondary text-right btn-close absolute left-5 cursor-pointer pt-5"
                >
                    <MWSVG id="ic_close" svgClassName="text-secondary" />
                </div>
                <InlineWidget styles={{ height: '100%' }} url="https://calendly.com/mowebsales/moweb-sales" />
            </Modal>
        </>
    );
};

export default UsaHero;
